import {
    downloadFile,
    getDataInternship,
    storeInternship,
    updateInternship,
    destroyInternship,
    getDataInternshipRejection,
    storeInternshipRejection,
    updateInternshipRejection,
    destroyInternshipRejection,
    kaprodiVerify,
    administratorVerify,
    lectureVerify,
    getDataRejection,
    kaprodiVerifyInternshipRejection,
} from '@/store/api/InternshipController'
const initialState = () => ({
    internships: {last_page: 0,data: [], total: 0},
    response: {},
    blobData: null,
    request:{
        page: 1,
        show: 10,
        sortBy: null,
        sorting: "DESC",
        search: null,
        filter: null,
        internshipType: 'Magang'
    },
})
const state = initialState

const getters = {
    getInternships: state => state.internships,
    getResponse: state => state.response,
    getRequest: state => state.request,
    getBlobData: state => state.blobData
}

const actions = {
    async downloadFile({commit }, {url, type}) 
    {
        try {
            var response = await downloadFile(url);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getDataInternship({commit, state }) 
    {
        try {
            const response = await getDataInternship(state.request);
            commit('SET_INTERNSHIPS', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getDataRejection({commit }, request) 
    {
        try {
            state.request = request
            var response = await getDataRejection(request);
            commit('SET_INTERNSHIPS', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async storeInternship({commit }, data) 
    {
        try {
            var response = await storeInternship(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async updateInternship({commit }, {id, data}) 
    {
        try {
            var response = await updateInternship(id, data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async kaprodiVerify({commit }, {id, data}) 
    {
        try {
            var response = await kaprodiVerify(id, data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async kaprodiVerifyInternshipRejection({commit }, {id, data}) 
    {
        try {
            var response = await kaprodiVerifyInternshipRejection(id, data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async administratorVerify({commit }, {id, data}) 
    {
        try {
            var response = await administratorVerify(id, data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async lectureVerify({commit }, id) 
    {
        try {
            var response = await lectureVerify(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async destroyInternship({commit }, id) 
    {
        try {
            var response = await destroyInternship(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getDataInternshipRejection({commit }, {id,request}) 
    {
        try {
            state.request = request
            var response = await getDataInternshipRejection(id,request);
            commit('SET_INTERNSHIPS', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async storeInternshipRejection({commit }, data) 
    {
        try {
            var response = await storeInternshipRejection(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async updateInternshipRejection({commit }, {id, data}) 
    {
        try {
            var response = await updateInternshipRejection(id, data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async destroyInternshipRejection({commit }, id) 
    {
        try {
            var response = await destroyInternshipRejection(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    }
}

const mutations = {
    SET_REQUEST(state, value){
        state.request.filter = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    SET_FAILED(state) {
        state.response = {
            msg: 'Jaringan Bermasalah',
            status: '0'
        }
    },
    SET_RESPONSE(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
    },
    SET_INTERNSHIPS(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.internships = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}